export const ASSETS_PATH = "https://assets.domun.co/prod";